import { useAppDataApi } from "../api/AppDataApiClient";
import { AppDataFrontendService } from "../services/AppDataFrontendService";

export const useAppDataService = (): AppDataFrontendService =>
  new AppDataFrontendService(useAppDataApi());
